export const Hero = (props) => {
    const {
        image,
        xPos = 'center',
        yPos = 'center',
    } = props;

    return (
        <div 
            className="addiko-hero"
            style={{ 
                backgroundImage: `url(/img/${image})`,
                backgroundPosition: `${xPos} ${yPos}`,
            }}
        >
            &nbsp;
        </div>
    );
};
